module.exports = __webpack_public_path__ + "static/media/sora_active3882be6257b1a4ea873680de1a1a133b.webp";